export default function CommunicationIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.46701 8.76714H11.8008M7.46701 11.8008H14.401M9.79316 17.0013H15.4411C16.8974 17.0013 17.6256 17.0013 18.1818 16.7179C18.6711 16.4686 19.0689 16.0708 19.3182 15.5815C19.6016 15.0253 19.6016 14.2972 19.6016 12.8409V8.16042C19.6016 6.70413 19.6016 5.97599 19.3182 5.41977C19.0689 4.9305 18.6711 4.53271 18.1818 4.28341C17.6256 4 16.8974 4 15.4411 4H8.16042C6.70413 4 5.97599 4 5.41977 4.28341C4.9305 4.53271 4.53271 4.9305 4.28341 5.41977C4 5.97599 4 6.70413 4 8.16042V19.0256C4 19.4875 4 19.7184 4.09467 19.837C4.17701 19.9401 4.30186 20.0001 4.43384 20C4.5856 19.9998 4.76592 19.8556 5.12657 19.5671L7.19417 17.913C7.61654 17.5751 7.82773 17.4061 8.0629 17.286C8.27153 17.1794 8.49362 17.1015 8.72313 17.0544C8.98181 17.0013 9.25226 17.0013 9.79316 17.0013Z"
        stroke={props?.stroke || "#00344A"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
